import React from 'react'
import Modal from '../../components/Modal/Modal'

const WORLD_CHAMPION_POINTS = 10

function RuleSection({ title, children }) {
  return (
    <section className="worldcup-rules-section">
      <h3 className="worldcup-rules-section-title">{title}</h3>
      <div className="worldcup-rules-section-body">{children}</div>
    </section>
  )
}

function ExampleCard({ title, lines }) {
  return (
    <div className="worldcup-rules-example">
      <strong className="worldcup-rules-example-title">{title}</strong>
      <ul className="worldcup-rules-list worldcup-rules-list--compact">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  )
}

export default function WorldCupRulesModal({ isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Spilregler"
      size="medium"
      className="worldcup-modal worldcup-rules-modal"
    >
      <div className="worldcup-rules">
        <p className="worldcup-rules-intro">
          Gæt resultater på VM-kampe, brug dine jokere med omhu, og vælg en verdensmester.
          Point tælles sammen på tværs af hele turneringen.
        </p>

        <RuleSection title="Sådan gætter du">
          <ul className="worldcup-rules-list">
            <li>Du skal afgive dit gæt <strong>inden kampens kickoff</strong> — herefter er gættet låst.</li>
            <li>Du kan kun gætte <strong>én gang per kamp</strong>, og gættet kan ikke ændres bagefter.</li>
            <li>Gå til fanen <strong>Kampe</strong>, tryk på en kamp og indtast dit resultat.</li>
            <li>Når kampen er spillet, beregnes dine point automatisk.</li>
          </ul>
        </RuleSection>

        <RuleSection title="Point per kamp">
          <p className="worldcup-rules-lead">Du kan få op til <strong>3 point</strong> på hver kamp:</p>
          <ul className="worldcup-rules-list">
            <li><strong>+1 point</strong> for rigtigt antal hjemmemål</li>
            <li><strong>+1 point</strong> for rigtigt antal udemål</li>
            <li><strong>+1 point</strong> ekstra for det præcise resultat</li>
          </ul>
          <p className="worldcup-rules-note">
            Pointene lægges sammen. Et helt rigtigt resultat giver derfor 3 point.
          </p>
        </RuleSection>

        <RuleSection title="Jokere">
          <ul className="worldcup-rules-list">
            <li>Du har <strong>3 jokere</strong> i hele spillet.</li>
            <li>Bruger du joker på en kamp, <strong>får du dobbelt point</strong> på den kamp.</li>
            <li>Et perfekt gæt med joker giver <strong>6 point</strong> (3 × 2).</li>
            <li>Vælg joker, når du afgiver gættet — du kan ikke tilføje den bagefter.</li>
          </ul>
        </RuleSection>

        <RuleSection title="Verdensmester">
          <ul className="worldcup-rules-list">
            <li>Vælg det hold, du tror vinder VM, under fanen <strong>Verdensmester</strong>.</li>
            <li>Du kan ændre valget indtil <strong>første kamp starter</strong>.</li>
            <li>Rigtigt gæt giver <strong>{WORLD_CHAMPION_POINTS} point</strong>.</li>
          </ul>
        </RuleSection>

        <RuleSection title="Leaderboard">
          <p className="worldcup-rules-lead">Spillere sorteres efter:</p>
          <ol className="worldcup-rules-list worldcup-rules-list--ordered">
            <li>Flest point i alt</li>
            <li>Flest perfekte gæt (3 point på en kamp)</li>
            <li>Flest point fra jokere</li>
          </ol>
        </RuleSection>

        <RuleSection title="Eksempler">
          <div className="worldcup-rules-examples">
            <ExampleCard
              title="Præcist resultat"
              lines={[
                'Resultat: 2-1 · Dit gæt: 2-1',
                '1 point for hjemmemål + 1 for udemål + 1 for præcis = 3 point',
              ]}
            />
            <ExampleCard
              title="Kun hjemmemål rigtigt"
              lines={[
                'Resultat: 2-1 · Dit gæt: 2-0',
                '1 point for hjemmemål · 0 for udemål · ikke præcis = 1 point',
              ]}
            />
            <ExampleCard
              title="Præcist resultat med joker"
              lines={[
                'Resultat: 1-1 · Dit gæt: 1-1 (joker)',
                '3 point × 2 = 6 point',
              ]}
            />
            <ExampleCard
              title="Forkert gæt"
              lines={[
                'Resultat: 3-0 · Dit gæt: 1-1',
                '0 point',
              ]}
            />
          </div>
        </RuleSection>
      </div>
    </Modal>
  )
}
